import React, { Component } from "react";

import "./TwoColumns.css";

export default class TwoColumns extends Component {
  render() {
    return (
      <div
        className={
          this.props.sidebarLayout
            ? "two-columns -sidebar"
            : "two-columns"
        }
      >
        <div className="left">{this.props.left}</div>
        <div className="right">{this.props.right}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TwoColumns/TwoColumns.js